export const ContentfulProducts = {
	Mortgage: '5Dd85DsFxZaIRnL6EVNRkt',
	CreditCards: '3wK7mRnu5cC1emYeUQFp2D',
	Savings: '7BYDVYpz96D7KywGt7F1DQ',
	Life_Insurance: 'lJWpRY7UjuyjGtphtLLh2',
	SLR: '20a8ggfH0sT4Dgjkr5e7Wr',
	Loans: '4CL6dNftTmvXGOP5hcJJ3V'
}

export const ContentfulTopics = {
	Auto_Refinance: '45SzjnaCrL8PLXlfPqQJ8G'
}
